import { SelectOption } from "@/models/selectOption";

export const ROLES = {
  ADMIN: 1,
  COMPANY_ADMIN: 2,
  ATTENDANT: 3,
  SPECIALIST: 4
}

export const ROLES_LABELS = {
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.COMPANY_ADMIN]: 'Administrador de Empresa',
  [ROLES.ATTENDANT]: 'Atendente',
  [ROLES.SPECIALIST]: 'Especialista',
}

export const ROLES_OPTIONS: SelectOption[] = [
  {
    label: ROLES_LABELS[ROLES.ADMIN],
    value: ROLES.ADMIN.toString(),
  },
  {
    label: ROLES_LABELS[ROLES.COMPANY_ADMIN],
    value: ROLES.COMPANY_ADMIN.toString(),
  },
  { value: ROLES.ATTENDANT.toString(), label: ROLES_LABELS[ROLES.ATTENDANT] },
  { value: ROLES.SPECIALIST.toString(), label: ROLES_LABELS[ROLES.SPECIALIST] },
];
